import { ServiceItem } from '../types';

/**
 * Gehoert eine LV-Position zur PLANUNGSPHASE oder zur AUSFUEHRUNG?
 *
 * EINE Regel fuer alle Ansichten (offene Positionen im Admin-Bereich,
 * Projektstand im Hub): Planung ist, was im Katalog als 'Entwurf' steht oder
 * einem Planungsdokument zugeordnet ist — SiGe-Plan, Unterlage (RAB 32),
 * allgemeine Planung.
 *
 * `einweisung` gehoert BEWUSST NICHT dazu: die Einweisung in den SiGe-Plan
 * findet auf der Baustelle waehrend der Ausfuehrung statt (ihre
 * Katalogposition traegt category 'Ausführung'). Alles, was nicht Planung
 * ist — auch 'Sonstiges' wie Fahrtkosten —, laeuft mit der Ausfuehrung.
 */
export const PLANUNGS_ZUORDNUNGEN: ReadonlyArray<string> = ['sigeplan', 'unterlage', 'planning_general'];

export const istPlanungsleistung = (
    s: Pick<ServiceItem, 'category' | 'assignment'> | { category?: string | null; assignment?: string | null } | null | undefined,
): boolean =>
    s?.category === 'Entwurf' || PLANUNGS_ZUORDNUNGEN.includes(s?.assignment || '');
